import request from "@/utils/request";

// 列表(主数据列表)
export function loadCrossBorderSellListDataApi(data) {
    return request({
      url: "web/crossBorderSell/listData",
      method: "post",
      data
    });
  }
  // 导出
  export function loadCrossBorderSellExportDataApi(data) {
    return request({
      url: "web/crossBorderSell/exportData",
      method: "post",
      data
    });
  }
  // 导出图片
  export function loadCrossBorderSellExportPicZipApi(data) {
    return request({
      url: "web/crossBorderSell/exportPicZip",
      method: "post",
      data
    });
  }
  // 导出图片PDF
  export function loadCrossBorderSellExportTracePicPDFApi(data) {
    return request({
      url: "web/crossBorderSell/exportTracePicPDF",
      method: "post",
      data
    });
  }
  
  // 保存
  export function saveOrUpdateCrossBorderSellApi(data) {
    return request({
      url: "web/crossBorderSell/saveOrUpdate",
      method: "post",
      data
    });
  }
  
  // 查看
  export function initCrossBorderSellApi(data) {
    return request({
      url: "web/crossBorderSell/initCrossBorderSell",
      method: "post",
      data
    });
  }
  
  // 下拉列表（下拉选择）
  export function loadCrossBorderSellListApi(data) {
    return request({
      url: "web/crossBorderSell/listSelectData",
      method: "post",
      data
    });
  }
  
  // 根据条件获取条数
  export function loadCrossBorderSellCountByConditionApi(data) {
    return request({
      url: "web/crossBorderSell/findCountByCondition",
      method: "post",
      data
    });
  }

  
// 明细列表(主数据列表)
export function loadCrossBorderSellMaterialsDetailListDataApi(data) {
  return request({
    url: "web/crossBorderSellMaterialsDetail/listData",
    method: "post",
    data
  });
}
// 明细导出
export function loadCrossBorderSellMaterialsDetailExportDataApi(data) {
  return request({
    url: "web/crossBorderSellMaterialsDetail/exportData",
    method: "post",
    data
  });
}
// 根据条件获取品牌推广物料明细
export function findCrossBorderSellMaterialsDetailByConditionApi(data) {
  return request({
    url: "web/crossBorderSellMaterialsDetail/findCrossBorderSellMaterialsDetailByCondition",
    method: "post",
    data
  });
}
// 根据派工单ID查询云相机数据
export function findPhotoInfoListByDispatchIdApi(data) {
  return request({
    url: "web/crossBorderSell/findPhotoInfoListByDispatchId",
    method: "post",
    data
  });
}
// 服务明细列表(主数据列表)
export function loadCrossBorderSellServiceItemListDataApi(data) {
  return request({
    url: "web/crossBorderSellServiceItem/listData",
    method: "post",
    data
  });
}
// 服务明细导出
export function loadCrossBorderSellServiceItemExportDataApi(data) {
  return request({
    url: "web/crossBorderSellServiceItem/exportData",
    method: "post",
    data
  });
}
// 终端展示宣传连续验证
export function findDisplayCountQuestionByIdApi(data) {
  return request({
    url: "web/crossBorderSell/findDisplayCountQuestionById",
    method: "post",
    data
  });
}